import { useNavigate, useLocation } from "react-router-dom";
import {
  Heart,
  MapPin,
  TrendUp,
  UserCircle,
} from "@phosphor-icons/react";

interface ActionButton {
  icon: React.ComponentType<any>;
  label: string;
  onClick: () => void;
  variant?: "primary" | "default" | "muted" | "accent";
}

interface BottomNavProps {
  onScanTap: () => void;
  onSaveTap?: () => void;
  selectedCount?: number;
  onHomeTap?: () => void;
  actions?: ActionButton[];
}

const BottomNav = ({ onScanTap, actions }: BottomNavProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: "/my-dishes", label: "faves", icon: Heart },
    { path: "/group", label: "my spots", icon: MapPin },
    { path: "__scan__", label: "snap", icon: null },
    { path: "/stats", label: "wrapped", icon: TrendUp },
    { path: "/taste-profile", label: "my vibe", icon: UserCircle },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[90] px-4" style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom, 0px))' }}>
      {actions && actions.length > 0 ? (
        <div className="max-w-lg mx-auto rounded-[28px] border border-white/20 bg-black/90 backdrop-blur-2xl shadow-[0_-8px_40px_rgba(0,0,0,0.32)] flex items-center justify-around py-2.5 px-3">
          {actions.map((action, i) => {
            const Icon = action.icon;
            const colorClass = action.variant === "primary"
              ? "text-orange-400"
              : action.variant === "accent"
              ? "text-amber-400"
              : action.variant === "muted"
              ? "text-white/40"
              : "text-white/70";
            return (
              <button
                key={i}
                onClick={action.onClick}
                className={`flex flex-col items-center justify-center gap-0.5 px-3 py-1 rounded-xl active:scale-90 transition-all ${colorClass}`}
              >
                <Icon size={20} weight="bold" />
                <span className="text-[10px] font-semibold" style={{ letterSpacing: '0.02em' }}>
                  {action.label}
                </span>
              </button>
            );
          })}
        </div>
      ) : (
        <div className="max-w-lg mx-auto rounded-[28px] border border-white/20 bg-black/90 backdrop-blur-2xl shadow-[0_-8px_40px_rgba(0,0,0,0.32)] flex items-center justify-around py-2 px-2">
          {tabs.map((tab) => {
            if (tab.path === "__scan__") {
              return (
                <button
                  key="scan"
                  onClick={onScanTap}
                  className="flex flex-col items-center gap-0.5 -mt-7 group"
                >
                  <div className="w-[64px] h-[64px] rounded-full bg-gradient-to-br from-orange-500 via-amber-500 to-yellow-400 p-[3px] group-active:scale-90 transition-transform shadow-[0_10px_30px_rgba(255,87,34,0.35)]">
                    <div className="w-full h-full rounded-full bg-black flex items-center justify-center border border-white/10">
                      <div className="w-9 h-9 rounded-full bg-white shadow-inner" />
                    </div>
                  </div>
                  <span className="text-[10px] font-bold text-white/70" style={{ letterSpacing: '0.02em' }}>
                    snap
                  </span>
                </button>
              );
            }
            const Icon = tab.icon!;
            const isActive = location.pathname === tab.path;
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                className="flex flex-col items-center justify-center gap-0.5 py-1.5 px-2 group active:scale-90 transition-all"
              >
                <Icon
                  size={22}
                  weight={isActive ? "fill" : "regular"}
                  className={`transition-colors ${isActive ? "text-white" : "text-white/50"}`}
                />
                <span
                  className={`text-[10px] font-semibold transition-colors ${isActive ? "text-white" : "text-white/50"}`}
                  style={{ letterSpacing: '0.02em' }}
                >
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </nav>
  );
};

export default BottomNav;
